// # Experiences section component for profile
import React from 'react';
import './prfl_experiences.css';

const ProfileExperiences = ({ isDarkMode }) => {
  return (
    <div className={`prfl_experiences_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_experiences_coming-soon">
        <h3>Experiences Feature Coming Soon</h3>
        <p>Share your clinical rotations, internships, and medical experiences.</p>
      </div>
    </div>
  );
};

export default ProfileExperiences;
